import clsx from "clsx";

const PHASES = [
  { id: "bronze", label: "Bronze", emoji: "🥉" },
  { id: "silver", label: "Silver", emoji: "🥈" },
  { id: "gold", label: "Gold", emoji: "🥇" },
  { id: "platinum", label: "Platinum", emoji: "💎" },
] as const;

interface GuildBattlePhaseStepperProps {
  phase: string | null | undefined;
  /** Pulse the current phase while a battle week is active */
  active?: boolean;
}

export function GuildBattlePhaseStepper({ phase, active }: GuildBattlePhaseStepperProps) {
  const currentIdx = PHASES.findIndex((p) => p.id === phase);

  return (
    <div className="flex items-stretch gap-1">
      {PHASES.map((p, i) => {
        const isCurrent = p.id === phase;
        const isPast = currentIdx >= 0 && i < currentIdx;
        const isFuture = currentIdx >= 0 && i > currentIdx;

        return (
          <div
            key={p.id}
            className={clsx(
              "flex-1 text-center py-2 px-1 rounded-lg border text-[10px] font-bold transition-colors",
              isCurrent &&
                active &&
                "animate-pulse border-amber-400 bg-amber-900/40 text-amber-100 shadow-[0_0_12px_rgba(251,191,36,0.35)]",
              isCurrent && !active && "border-amber-500/70 bg-amber-950/30 text-amber-200",
              isPast && "border-emerald-800/60 bg-emerald-950/25 text-emerald-300",
              isFuture && "border-kingdom-mid bg-kingdom-dark/40 text-gray-500",
              currentIdx < 0 && "border-kingdom-mid text-gray-500",
            )}
          >
            <span className="block text-base leading-none mb-0.5">{p.emoji}</span>
            {p.label}
          </div>
        );
      })}
    </div>
  );
}
